import { snackbar as customSnackbar } from "./snackbar";

// Helper function to dismiss only snackbar notifications
const dismissAllSnackbars = () => {
  // Get all snackbar elements with our specific class
  const snackbarElements = document.querySelectorAll('.wl-snackbar-notification');
  snackbarElements.forEach((element) => {
    // Find the snackbar ID and dismiss it
    const snackbarId = element.getAttribute('data-sonner-toast-id');
    if (snackbarId) {
      customSnackbar.dismiss(snackbarId);
    }
  });
};

/**
 * Custom hook for managing snackbar notifications.
 * 
 * @returns Object with snackbar methods
 */
export function useSnackbar() {
  return {
    /**
     * Show a default snackbar notification.
     */
    snackbar: (title: string, options?: any) => {
      console.log("useSnackbar.snackbar called with:", title, options);
      return customSnackbar.show(title, options);
    },
    /**
     * Show a success snackbar notification.
     */
    success: (title: string, options?: any) => {
      console.log("useSnackbar.success called with:", title, options);
      return customSnackbar.success(title, options);
    },
    /**
     * Show an error snackbar notification.
     */
    error: (title: string, options?: any) => {
      console.log("useSnackbar.error called with:", title, options);
      return customSnackbar.error(title, options);
    },
    /**
     * Show a warning snackbar notification.
     */
    warning: (title: string, options?: any) => {
      console.log("useSnackbar.warning called with:", title, options);
      return customSnackbar.warning(title, options);
    },
    /**
     * Show an info snackbar notification.
     */
    info: (title: string, options?: any) => {
      console.log("useSnackbar.info called with:", title, options);
      return customSnackbar.info(title, options);
    },
    /**
     * Show a promise-based snackbar notification.
     */
    promise: (promise: Promise<any>, options: any) => {
      console.log("useSnackbar.promise called with:", promise, options);
      return customSnackbar.promise(promise, options);
    },
    /**
     * Dismiss a specific snackbar by ID.
     */
    dismiss: (snackbarId?: string | number) => {
      console.log("useSnackbar.dismiss called with:", snackbarId);
      if (snackbarId) {
        customSnackbar.dismiss(snackbarId);
      } else {
        // If no ID provided, dismiss all snackbars
        dismissAllSnackbars();
      }
    },
    /**
     * Dismiss all currently visible snackbars.
     */
    dismissAll: () => {
      console.log("useSnackbar.dismissAll called");
      dismissAllSnackbars();
    },
  };
}
